var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline';
import { Translate } from "../../../I18N";









const VerticalDrawer = ({
  title,
  children,
  maxHeight = 'h-fit',
  className = 'bg-white border-t border-gray-200 shadow-[0_-6px_12px_-3px_rgba(0,0,0,0.15)]',
  defaultOpen = false
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (/*#__PURE__*/
    _jsx("div", { className: className }, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex items-center justify-between bg-gray-50 px-4 py-2" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex-1" }, void 0, title), /*#__PURE__*/
    _jsx("div", { className: "flex items-center gap-2" }, void 0, /*#__PURE__*/
    _jsx("button", {
      type: "button",
      onClick: () => setIsOpen(!isOpen),
      className: "text-gray-400 hover:text-gray-600 transition-colors" }, void 0, /*#__PURE__*/

    _jsx("span", { className: "sr-only" }, void 0,
    isOpen ? /*#__PURE__*/_jsx(Translate, {}, void 0, "Close") : /*#__PURE__*/_jsx(Translate, {}, void 0, "Open")
    ), /*#__PURE__*/
    _jsx("span", { className: "text-lg" }, void 0,
    isOpen ? /*#__PURE__*/_jsx(ChevronDownIcon, { width: 20 }) : /*#__PURE__*/_jsx(ChevronUpIcon, { width: 20 })
    )
    )
    )
    ), /*#__PURE__*/

    _jsx("div", {
      "aria-hidden": isOpen ? 'false' : 'true',
      className: `${isOpen ? '' : 'hidden'} ${maxHeight} overflow-y-auto px-4 py-2` }, void 0,

    children
    )
    ));

};

export { VerticalDrawer };